import api from './api';
import {
    DeliveryFeeConfig,
    DeliveryFeeConfigWithTiers,
    DeliveryFeeConfigCreate,
    DeliveryFeeTierCreate,
    DeliveryFeeCalculationRequest,
    DeliveryFeeCalculationResponse
} from '../types/deliveryFee';

export const deliveryFeeService = {
    // Configurations
    async getAll(): Promise<DeliveryFeeConfig[]> {
        const response = await api.get('/delivery-fee-configs');
        return response.data;
    },

    async getById(id: number): Promise<DeliveryFeeConfigWithTiers> {
        const response = await api.get(`/delivery-fee-configs/${id}`);
        return response.data;
    },

    async create(data: DeliveryFeeConfigCreate): Promise<DeliveryFeeConfig> {
        const response = await api.post('/delivery-fee-configs', data);
        return response.data;
    },

    async update(id: number, data: Partial<DeliveryFeeConfigCreate>): Promise<DeliveryFeeConfig> {
        const response = await api.patch(`/delivery-fee-configs/${id}`, data);
        return response.data;
    },

    async delete(id: number): Promise<void> {
        await api.delete(`/delivery-fee-configs/${id}`);
    },

    // Tiers
    async createTier(configId: number, data: DeliveryFeeTierCreate): Promise<any> {
        const response = await api.post(`/delivery-fee-configs/${configId}/tiers`, data);
        return response.data;
    },

    async deleteTier(configId: number, tierId: number): Promise<void> {
        await api.delete(`/delivery-fee-configs/${configId}/tiers/${tierId}`);
    },

    // Calculate
    async calculate(data: DeliveryFeeCalculationRequest): Promise<DeliveryFeeCalculationResponse> {
        const response = await api.post('/delivery-fee-configs/calculate', data);
        return response.data;
    },

    // Client calculate (for order form)
    async calculateEstimate(data: DeliveryFeeCalculationRequest): Promise<{
        delivery_fee: number;
        tax_amount: number;
        total_amount: number;
        breakdown: {
            calculation?: string;
            message?: string;
            is_free_delivery?: boolean;
        };
    }> {
        const response = await api.post('/clients/me/calculate-delivery-fee', data);
        return response.data;
    }
};
